<template>
  <div class="full">
    <div class="bg full">
      <div class="full" v-show="openvisible">
        <p class="title" id="starttitle"></p>
        <p class="question center" id="startcon"></p>
        <audio style="display: none" autoplay id="startaudio" src=""></audio>
      </div>
      <template v-if="!openvisible">
        <div v-for="(i, index) in list" :key="index">
          <template v-if="index == id">
            <p class="title">{{ i.title }}</p>
            <p class="question center" v-html="i.ques">{{i.ques }} </p>
            <audio style="display: none" autoplay>
              <source :src="i.sound" type="audio/mpeg" />
            </audio>
            <div class="bottom center" style="text-align: center">
              <el-button type="primary" @click="next(id)">下一页</el-button>
            </div>
          </template>
        </div>
      </template>
    </div>
    <audio controls="controls" ref="audio" style="display: none">
      <source :src="musicUrl" type="audio/mpeg" />
    </audio>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :show-close="false"
      width="95%"
    >
      <el-radio-group v-model="radio" @change="soundPlay()">
        <el-row :gutter="10">
          <el-col :xs="8" :sm="3"
            ><el-radio label="点赞" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="膜拜" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="哈哈" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="开心" size="mini" border></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="赞许" size="mini" border></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="加油" size="mini" border></el-radio
          ></el-col>
          <el-col :xs="8" :sm="6"
            ><el-radio label="抱抱" size="mini" border></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="理解" size="mini" border></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="赞同" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="感动" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="感激" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="满意" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="心疼" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="6"
            ><el-radio label="安慰" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="吐舌" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="无语" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="呵呵" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="囧囧" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="惊讶" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="3"
            ><el-radio label="担心" border size="mini"></el-radio
          ></el-col>
          <el-col :xs="8" :sm="6"
            ><el-radio label="流泪" border size="mini"></el-radio
          ></el-col>
        </el-row>
      </el-radio-group>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          type="primary"
          @click="
            dialogVisible = false;
            getNumber(id);
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export default {
  data() {
    return {
      openid: 0,
      id: 0,
      radio: "",
      dialogVisible: false,
      form: {
        iphone: "",
        imei: "",
      },
      imei: "test",
      welcome: "欢迎帅哥",
      title: "请对方点击一个听后感想",
      question: "你们很有缘分哦！可以一起玩我们这个小游戏！",
      list: [],
      musicUrl: "",
      openvisible: true,
      startlist: [],
    };
  },

  methods: {
    async onload() {
      this.autoPlay();
    },
    autoPlay() {
      this.startlist = [
        {
          title: "",
          ques: "帅哥美女，你们好！",
          sound: "", //require("@/assets/sounds/start_page1.mp3")
          t: 3000,
        },
        {
          title: "",
          ques: "你们很有缘分哦！可以一起玩我们这个小游戏！",
          sound: "",
          t: 4300,
        },
        {
          title: "",
          ques: "玩这个游戏时，你们一定要诚实和真诚，才会好玩的！",
          sound: "",
          t: 5000,
        },
        {
          title: "",
          ques: "请你们俩一起轮流真诚地回答下面的问题",
          sound: "",
          t: 4200,
        },
        {
          title: "",
          ques: "比如：帅哥先回答，回答完了，点击＂下一页＂",
          sound: "",
          t: 5000,
        },
        {
          title: "",
          ques: "然后，美女点击一个听帅哥回答的感想",
          sound: "",
          t: 4500,
        },
        {
          title: "",
          ques: "接着，美女回答，回答完了点击＂下一页＂",
          sound: "",
          t: 4000,
        },
        {
          title: "",
          ques: "然后，帅哥点击一个听美女回答的感想",
          sound: "",
          t: 4000,
        },
        {
          title: "",
          ques: "注意：必须诚实地回答",
          sound: "",
          t: 2800,
        },
        {
          title: "",
          ques: "如果不诚实，这个游戏就不好玩了",
          sound: "",
          t: 3500,
        },
        {
          title: "",
          ques: "现在游戏开始了!",
          sound: "",
          t: 2600,
        },
        {
          title: "",
          ques: "",
          sound: require("@/assets/sounds/start.mp3"),
          t: 0,
        },
      ];

      var title = document.getElementById("starttitle");
      var con = document.getElementById("startcon");
      var sound = document.getElementById("startaudio");
      var t = this.startlist[0].t;
      title.innerHTML = this.startlist[0].title;
      con.innerHTML = this.startlist[0].ques;

      var audio_start = new Audio(this.startlist[11].sound);
      audio_start.play();
      setTimeout(() => {
        title.innerHTML = this.startlist[1].title;
        con.innerHTML = this.startlist[1].ques;
        t = this.startlist[1].t;
        setTimeout(() => {
          title.innerHTML = this.startlist[2].title;
          con.innerHTML = this.startlist[2].ques;
          t = this.startlist[2].t;
          setTimeout(() => {
            title.innerHTML = this.startlist[3].title;
            con.innerHTML = this.startlist[3].ques;
            t = this.startlist[3].t;
            setTimeout(() => {
              title.innerHTML = this.startlist[4].title;
              con.innerHTML = this.startlist[4].ques;
              t = this.startlist[4].t;
              setTimeout(() => {
                title.innerHTML = this.startlist[5].title;
                con.innerHTML = this.startlist[5].ques;
                t = this.startlist[5].t;
                setTimeout(() => {
                  title.innerHTML = this.startlist[6].title;
                  con.innerHTML = this.startlist[6].ques;
                  t = this.startlist[6].t;
                  setTimeout(() => {
                    title.innerHTML = this.startlist[7].title;
                    con.innerHTML = this.startlist[7].ques;
                    t = this.startlist[7].t;
                    setTimeout(() => {
                      title.innerHTML = this.startlist[8].title;
                      con.innerHTML = this.startlist[8].ques;
                      t = this.startlist[8].t;
                      setTimeout(() => {
                        title.innerHTML = this.startlist[9].title;
                        con.innerHTML = this.startlist[9].ques;
                        t = this.startlist[9].t;
                        setTimeout(() => {
                          title.innerHTML = this.startlist[10].title;
                          con.innerHTML = this.startlist[10].ques;
                          t = this.startlist[10].t;
                          setTimeout(() => {
                            title.innerHTML = this.startlist[11].title;
                            con.innerHTML = this.startlist[11].ques;
                            t = this.startlist[11].t;
                            setTimeout(() => {
                              this.openvisible = false;
                              this.getQuestion();
                            }, t);
                          }, t);
                        }, t);
                      }, t);
                    }, t);
                  }, t);
                }, t);
              }, t);
            }, t);
          }, t);
        }, t);
      }, t);
    },
    autoPlayEnd(){
      this.endList =[
        {
          title: "",
          ques: "请帅哥向美女分享一个自己的私人困扰或烦恼",
          sound: require("@/assets/sounds/请帅哥向美女分享一个自己的私人困扰或烦恼.mp3"),
          t:6000,
        },
        {
          title: "",
          ques: "请美女换位思考体会帅哥的烦恼,理解帅哥，并帮助帅哥提供解决困扰的建议，同时安慰帅哥",
          sound: require("@/assets/sounds/请美女换位思考.mp3"),
          t: 12500,
        },
        // {
        //   title: "",
        //   ques: "并帮助帅哥提供解决困扰的建议，同时安慰帅哥",
        //   sound: require("@/assets/sounds/请美女换位思考2.mp3"),
        //   t: 6000,
        // },
        {
          title: "",
          ques: "请美女向帅哥分享一个自己的私人困扰或烦恼",
          sound: require("@/assets/sounds/请美女向帅哥分享一个自己的私人困扰或烦恼.mp3"),
          t: 6000,
        },
        {
          title: "",
          ques: "请帅哥换位思考体会美女的烦恼,理解美女,并帮助美女提供解决困扰的建议，同时安慰美女",
          sound: require("@/assets/sounds/请帅哥换位思考.mp3"),
          t: 12500,
        },
        // {
        //   title: "",
        //   ques: "",
        //   sound: require("@/assets/sounds/请帅哥换位思考2.mp3"),
        //   t: 6000,
        // }
      ];

      var title = document.getElementById("starttitle");
      var con = document.getElementById("startcon");
      var sound = document.getElementById("startaudio");
      var t = this.endList[0].t;
      sound.src = this.endList[0].sound;
      sound.play();
      title.innerHTML = this.endList[0].title;
      con.innerHTML = this.endList[0].ques;
      setTimeout(()=>{
        title.innerHTML = this.endList[1].title;
        con.innerHTML = this.endList[1].ques;
        t = this.endList[1].t;
        sound.src = this.endList[1].sound;
        sound.play();
        setTimeout(()=>{
          title.innerHTML = this.endList[2].title;
          con.innerHTML = this.endList[2].ques;
          t = this.endList[2].t;
          sound.src = this.endList[2].sound;
          sound.play();
          setTimeout(()=>{
            title.innerHTML = this.endList[3].title;
            con.innerHTML = this.endList[3].ques;
            t = this.endList[3].t;
            sound.src = this.endList[3].sound;
            sound.play();
            setTimeout(()=>{
              title.innerHTML = this.endList[4].title;
              con.innerHTML = this.endList[4].ques;
              t = this.endList[4].t;
              sound.src = this.endList[4].sound;
              sound.play();
              setTimeout(()=>{
                title.innerHTML = this.endList[5].title;
                con.innerHTML = this.endList[5].ques;
                t = this.endList[5].t;
                sound.src = this.endList[5].sound;
                sound.play();
                setTimeout(()=>{
                  //this.openvisible = true;
                  var con = document.getElementById("startcon");
                  console.log(con);
                  var sound = document.getElementById("startaudio");
                  con.innerHTML = '此时，两人不要说话，请你们俩<br/>互相凝视两分钟! <i class="el-icon-loading"></i>';
                  sound.src = require("@/assets/sounds/此时两人不要说话.mp3");
                  console.log(sound);
                  sound.play();
                  setTimeout(() => {
                    this.$router.push({ path: "/information" });
                  }, 10000); //120000
                },t);
              },t);
            },t);
          },t);
        },t);
      },t);
    },
    async getQuestion() {
      let tempArr = [];
      const res = await axios
        .get("http://gameserver.9help.net/ManageCenter/GetAllQuestions", {})
        .then(function (res) {
          const { data } = res;
          if (data.code == 0) {
            tempArr = data.data;
          } else {
            alert("发生错误，请刷新页面！或联系管理员");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      //console.log(tempArr);
      tempArr.forEach((i) => {
        var man = "请帅哥回答";
        var miss = "请美女回答";
        i.sound = `http://gameserver.9help.net/${i.sound}`;
        if (i.sex == 0) {
          this.$set(i, "title", man);
        } else if (i.sex == 1) {
          this.$set(i, "title", miss);
        }
        this.list.push(i);
      });

      var endlist = [
        {
          title: "",
          ques: "请帅哥向美女分享一个自己的私人困扰或烦恼",
          sound: require("@/assets/sounds/请帅哥向美女分享一个自己的私人困扰或烦恼.mp3"),
        },
        {
          title: "",
          ques: "<p>请美女换位思考体会帅哥的烦恼,理解帅哥，</p><p>并帮助帅哥提供解决困扰的建议，同时安慰帅哥</p>",
          sound: require("@/assets/sounds/请美女换位思考.mp3"),
        },
        // {
        //   title: "",
        //   ques: "并帮助帅哥提供解决困扰的建议，同时安慰帅哥",
        //   sound: require("@/assets/sounds/请美女换位思考2.mp3"),
        // },
        {
          title: "",
          ques: "请美女向帅哥分享一个自己的私人困扰或烦恼",
          sound: require("@/assets/sounds/请美女向帅哥分享一个自己的私人困扰或烦恼.mp3"),
        },                                           
        {
          title: "",
          ques: "<p>请帅哥换位思考体会美女的烦恼,理解美女，</p><p>并帮助美女提供解决困扰的建议，同时安慰美女</p>",
          sound: require("@/assets/sounds/请帅哥换位思考.mp3"),
        },
        // {
        //   title: "",
        //   ques: "并帮助美女提供解决困扰的建议，同时安慰美女",
        //   sound: require("@/assets/sounds/请帅哥换位思考2.mp3"),
        // },
      ];
      this.list = [...this.list, ...endlist];
      //console.log(this.list);
    },

    getNumber(t) {
      // if (this.list[t].sex == 0) {
      //   this.title = "请美女点击一个听后感想";
      // } else if (this.list[t].sex == 1) {
      //   this.title = "请帅哥点击一个听后感想";
      // }

      this.title = "请对方点击一个听后感想";
      t++;
      setTimeout(()=>{
        this.id = t;
      },2000);
      
      this.radio = "";
    },
    // autoPlay(id,src){
    //   var  audio = document.getElementById(id);
    //   audio.src = src;
    //   audio.play();
    //   document.addEventListener( "WeixinJSBridgeReady" ,  function  () {
    //          audio.play();
    //  },  false );
    // },
    next(t) {
      var listlength = this.list.length;
      if (listlength - t <= 4 && t != this.list.length) {//4
        t++;
      }

      if (t >= this.list.length) {
        this.dialogVisible = false;
        this.openvisible = true;
        
        this.openvisible = true;
        var con = document.getElementById("startcon");
        var sound = document.getElementById("startaudio");
        con.innerHTML =
          '此时，两人不要说话，<br/>请你们俩互相<br/>凝视两分钟! <i class="el-icon-loading"></i>';
        sound.src = require("@/assets/sounds/此时两人不要说话.mp3");
        sound.play();
        setTimeout(() => {
          this.$router.push({ path: "/information" });
        }, 50000); //50000
      }
      if (this.id >= 0 && t < listlength - 4) {  //4
        this.dialogVisible = true;
      }

      setTimeout(()=>{
        this.id = t;
      },2000);
      
    },
    end() {
      setTimeout(() => {
        this.$alert("恭喜你们，提问环节已经结束", {
          confirmButtonText: "请互相双方向对方介绍自己",
          callback: (action) => {
            this.$router.push({ path: "/information" });
          },
        });
      }, 60000);
    },
    soundPlay() {
      this.musicUrl = require(`@/assets/sounds/${this.radio}.mp3`);            
      this.$refs.audio.load();
      this.$refs.audio.play();
    },
  },
  mounted() {
    this.onload();
  },
};
</script>